export default {
  activateLandingPageTitle: '活动',
  activateProductCardTitle: '活动',
  activateProductPageTitle: '预订活动',
  allProductsLandingPageTitle: '预订独特体验',
  apply: '应用',
  buyTickets: '购买门票',
  cancel: '取消',
  clear: '清除',
  clearFilters: '清除筛选',
  discoverExperiences: '发现体验',
  exclusive: '专属',
  experience: '体验',
  experiencePhotoOfListing: '体验照片 {{photoNumber}}，来自 {{listingTitle}}',
  experiences: '体验',
  filterExperiences: '筛选体验',
  hostedBy: '由...提供',
  hostLandingPageTitle: '本地体验',
  hostProductCardTitle: '本地体验',
  hostProductPageTitle: '预订本地体验',
  landingPageTitle: '预订独特体验',
  mainLandingPageTitle: '全部体验',
  more: '更多',
  noExperiencesFound: '未找到体验',
  noExperiencesFoundFor: '未找到与之匹配的体验',
  profileImageOfHost: '{{hostName}} 的头像',
  reserve: '预订',
  reserveLandingPageTitle: '活动与设施',
  reserveProductCardTitle: '活动',
  reserveProductPageTitle: '预订活动与设施',
  resultsPageTitle: '预订体验与活动',
};
